export default (that) => [
  {
    text: that.$l('menu_text_approved') || '审核通过',
    icon: 'el-icon-circle-check',
    menuType: 'approved',
  },
  {
    text: that.$l('menu_text_rejected') || '不通过',
    icon: 'el-icon-circle-close',
    menuType: 'rejected',
  },
]
